import { render, staticRenderFns } from "./NetWorthStatement.vue?vue&type=template&id=5c0c71fc&scoped=true"
import script from "./NetWorthStatement.vue?vue&type=script&lang=js"
export * from "./NetWorthStatement.vue?vue&type=script&lang=js"
import style0 from "./NetWorthStatement.vue?vue&type=style&index=0&id=5c0c71fc&prod&scoped=true&lang=css"
import style1 from "./NetWorthStatement.vue?vue&type=style&index=1&id=5c0c71fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c71fc",
  null
  
)

export default component.exports